import classNames from 'classnames';
import React, { FunctionComponent, useState } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import { PrimaryButton } from 'app/common/components/controls/button/button';
import { OnboardingDialog } from './OnboardingDialog';

import { AtlassianAccountOnboardingLinks } from '../AtlassianAccountOnboardingLinks';
// eslint-disable-next-line @trello/less-matches-component
import styles from './AtlassianAccountOnboardingOverlay.less';

const format = forNamespace(['aa onboarding', 'dialog'], {
  shouldEscapeStrings: false,
});

interface AccountTypeProps {
  aaEmail: string;
  orgName: string;
  onClickWorkAndOthers: () => void;
  onClickNotWork: () => void;
  onDismiss: () => void;
}

enum ActionTypes {
  workAndOther = 'workAndOther',
  notWork = 'notWork',
}

export const AccountTypeV2: FunctionComponent<AccountTypeProps> = ({
  aaEmail,
  orgName,
  onClickWorkAndOthers,
  onClickNotWork,
  onDismiss,
}) => {
  const [currentActionSelection, setCurrentActionSelection] = useState(
    ActionTypes.workAndOther,
  );

  const onClickContinue = () => {
    if (currentActionSelection === ActionTypes.workAndOther) {
      onClickWorkAndOthers();
    } else {
      onClickNotWork();
    }
  };

  return (
    <OnboardingDialog
      title={format('account usage')}
      helpLink={AtlassianAccountOnboardingLinks.HelpV2}
      closeDialog={onDismiss}
    >
      <div className={styles.largeActionContainer}>
        <div
          role="button"
          className={classNames(styles.largeButton, {
            [styles.activeButton]:
              currentActionSelection === ActionTypes.workAndOther,
          })}
          onClick={() => setCurrentActionSelection(ActionTypes.workAndOther)}
        >
          <h3>{format('org and other things', { org: orgName })}</h3>
          <p>{format('org and other msg')}</p>
        </div>
        <div
          role="button"
          className={classNames(styles.largeButton, {
            [styles.activeButton]:
              currentActionSelection === ActionTypes.notWork,
          })}
          onClick={() => setCurrentActionSelection(ActionTypes.notWork)}
        >
          <h3>{format('not for org', { org: orgName })}</h3>
          <p>{format('not for org msg', { org: aaEmail })}</p>
        </div>
      </div>
      <div className={styles.section}>
        <PrimaryButton onClick={onClickContinue}>
          {format('continue')}
        </PrimaryButton>
      </div>
    </OnboardingDialog>
  );
};
